export const MULTI_PREFERENCE_SEPARATOR = ' | ';

/**
 * Codifica un array di valori in una stringa separata da
 * MULTI_PREFERENCE_SEPARATOR.
 * E' l'identificativo del valore del widget multi-preference per le
 * esportazioni.
 */
export function computeMultiPreferenceTransformId(
  selectedValues: Array<string | null>,
): string | null {
  if (
    selectedValues.some(value => value === null) ||
    selectedValues.length === 0
  ) {
    return null;
  }

  return selectedValues.join(MULTI_PREFERENCE_SEPARATOR);
}
